'use client';
var classes = {"root":"m-89ab340","navbar":"m-45252eee","aside":"m-9cdde9a","header":"m-3b16f56b","main":"m-8983817","footer":"m-3840c879","section":"m-6dcfc7c7"};

export default classes;
//# sourceMappingURL=AppShell.module.mjs.map
